import React, { Suspense } from 'react';

import { FormattedMessage } from 'react-intl';

import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { ApplicationModes } from '../../../../common/constants/application-modes';
import { useAppContext } from '../../../../common/ui/app-context';
import { useApplicationMode } from '../../../../controllers/store/bootstrap';

import { messages } from './messages';

const Image = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/search-page/search-error-image" */ './image'
		),
);

const containerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: 'space.200',
	color: 'color.text',
});

const imageFallbackStyles = xcss({
	width: '124px',
	height: '124px',
});

const headingStyles = xcss({
	font: 'font.heading.small',
	fontWeight: 'font.weight.medium',
	marginTop: 'space.100',
});

const bodyStyles = xcss({
	marginTop: 'space.100',
	font: 'font.body',
});

export const LandingScreen = (): React.JSX.Element => {
	const applicationMode = useApplicationMode();
	const { isAdminHubAIEnabled, isRovoLLMEnabled } = useAppContext();

	const bodyCopy =
		applicationMode === ApplicationModes.Rovo
			? messages.quickFindNoContentBodyWithRovo
			: isAdminHubAIEnabled
				? messages.quickFindNoContentBodyWithAtlassianIntelligence
				: messages.quickFindNoContentBodyDefault;

	const newBodyCopy =
		(applicationMode === ApplicationModes.Rovo && isRovoLLMEnabled) || isAdminHubAIEnabled
			? messages.quickFindNoContentBodyWithAI
			: messages.quickFindNoContentBody;

	return (
		<Box xcss={containerStyles}>
			<Suspense fallback={<Box xcss={imageFallbackStyles} />}>
				{/* eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details */}
				<Image />
			</Suspense>
			<Box xcss={headingStyles}>
				<FormattedMessage
					{...(fg('rovo_search_updated_entitlement_checks_for_team_25') ? newBodyCopy : bodyCopy)}
				/>
			</Box>
			<Box xcss={bodyStyles}>
				<FormattedMessage {...messages.quickFindNoContentHeading} />
			</Box>
		</Box>
	);
};
